import { render, staticRenderFns } from "./SummaryList.vue?vue&type=template&id=51b717fb&"
import script from "./SummaryList.vue?vue&type=script&lang=ts&"
export * from "./SummaryList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports